import React from 'react';
import Chart from 'react-apexcharts';


class LineBarChartBrandSecurity extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        options: {
          chart: {
            id: 'line-bar-chart'
          },
          xaxis: {
            categories: [
              'Fake Social Medias',
              'Look A like Domains',
              'Rouge Mobile Apps',
            ]
          },
          colors: ['#008FFB', '#08283f'],
          yaxis: [{
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              style: {
                colors: '#008FFB',
              }
            },
            title: {
              // text: 'No. of Instance',
              style: {
                color: '#008FFB',
              },
            },
            min: 0,  // Minimum value for the left side
            // max: 4000, // Maximum value for the left side
          }, {
            opposite: true,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#08283f'
            },
            labels: {
              style: {
                colors: '#08283f',
              }
            },
            title: {
              // text: 'No. of Companies',
              style: {
                color: '#08283f',
              },
            },
            min: 0,  // Minimum value for the right side
            // max: 60, // Maximum value for the right side
          }],          
        },
        series: [
          {
            name: 'No. of Instance',
            type: 'column',
            data: [
              props?.brandsecurity?.totalInstancesOfFakeSocialMediaProfiles,
              props?.brandsecurity?.totalInstancesOfLookAlikeDomains,
              props?.brandsecurity?.totalInstancesOfRogueMobileApplications
            ]
          },
          {
          name: 'No. of Companies',
          type: 'line',
          data: [
            props?.brandsecurity?.totalCompaniesWithFakeSocialMediaProfiles,
            props?.brandsecurity?.totalCompaniesWithLookAlikeDomains,
            props?.brandsecurity?.totalCompaniesWithRougeMobileApplications,

          ]
        }],
      };
    }
  
    render() {
      return (
        <div id="chart">
          <Chart options={this.state.options} series={this.state.series} className="chart-class" type="line" height={400} />
        </div>
      );
    }
  }
  
  export default LineBarChartBrandSecurity;
  